import * as React from 'react'

import { useUnsafeAsyncData } from 'modules/core/hooks/useAsyncData'

import type Form from 'modules/enps/store/models/Form'
import formAccessGroupMemberships from 'modules/surveys/store/collections/formAccessGroupMemberships'

export default function useFormAccessGroup(form: Form) {
  const [accessGroup, setAccessGroup] = React.useState()

  const { loading } = useUnsafeAsyncData(async () => {
    const { id, access_group_id } = form.attributes

    const access_group = await formAccessGroupMemberships.fetch({
      data: {
        form_id: id,
        access_group_id: access_group_id,
      },
    })
    setAccessGroup(access_group)
  }, [form])

  return {
    accessGroup,
    loading,
  }
}
